export default class CampaignCtrl {
    constructor($scope, $filter, $window, $timeout, $rootScope, $stateParams, $state, AbTest, SideMenu, Events, Statistics, Campaign, Transaction) {
        SideMenu.setActive('campaign');

        this._stateParams = $stateParams;
        this._window = $window;
        this._state = $state;
        this._timeout = $timeout;
        this._filter = $filter;
        this._scope = $scope;
        this._rootScope = $rootScope;

        this.transactionRepo = Transaction;
        this.campaignRepo = Campaign;
        this.abTestRepository = AbTest;
        this.statisticRepo = Statistics;
        this.eventHandler = Events;
        
        var preferences = this._window.localStorage.getItem('settings.campaign.view');
        
        this.searchTimeout = false;
        this.reset = false;
        this.status = (this._stateParams.folder !== 'undefined' && this._stateParams.folder) ? this._stateParams.folder : 'sent';
        this.view = this._stateParams.view ? this._stateParams.view :  (['list', 'cards', 'admin'].includes(preferences) ? preferences : 'cards');
        this.currentPage = this._stateParams.page ? this._stateParams.page : 1;
        this.fetchingCampaigns = true;
        this.finished = false;
        this.campaigns = [];
        this.transactions = [];

        this.preventPaginatorInitialTrigger = this.currentPage != 1;

        this.abTestStatusMap = {
            1: 'draft',
            2: 'sending',
            3: 'sent',
            4: 'scheduled',
            5: 'paused',
            6: 'testing'
        };

        this.optionsByStatus = {
            sent: {copy: true, statistics: true},
            draft: {edit: true, schedule: true, remove: true, copy: true},
            sending: {edit: true, pause: true, copy: true},
            scheduled: {edit: true, schedule: true, remove: true, copy: true},
            paused: {statistics: true, restart: true, remove: true, copy: true}
        };

        this._scope.$watch(() => this.currentPage, (newVal, oldVal) => {
            if (newVal && ! this.reset) {
                if (this.preventPaginatorInitialTrigger && (newVal == 1 && oldVal > 1)) {
                    this.currentPage = oldVal;
                    this.reset = true;
                    this.preventPaginatorInitialTrigger = false;
                    return;
                }

                this._state.go($state.current, { page: newVal }, { notify: false });
                this.setPage();
            } else if (this.reset) {
                this.reset = false;
            }
        });

        this.campaignRepo.exportProgress().then((progress) => {
            if (progress && progress.meta && progress.meta.state == 'Finished' && progress.url) {
                this.exportFileUrl = progress.url;
            } else if (progress && progress.meta && progress.meta.state == 'Exporting') {
                $scope.exportRunning = true;
                this._rootScope.$emit('progress:start', 'campaign-export');
            }
        });

        this._rootScope.$on('campaign:export:completed', (event, url) => {
            this.exportRunning = false;
            this.exportFileUrl = url;
        });
    }
        
    setView(view) {
        this._window.localStorage.setItem('settings.campaign.view', view);

        if (this._stateParams.folder) {
            this._state.go(this._state.current, { view: view });
        } else {
            this._state.go('campaign.folder', {folder: 'sent', view: view, page: this.currentPage});
        }
    };

    isAbTest(campaign) {
        return campaign != null && campaign.ab_test_status_id > 0;
    };

    setPage() {
        this.campaigns = [];
        this.fetchingCampaigns = true;

        if (this.status == "transactional") {
            this.transactionRepo.findAllByName(this.currentPage, this.view, this.search).then((results) => {
                this.handleTransactionalResponse(results);
            });
        } else {
            if (this.search && this.search.length) {
                this.campaignRepo.searchByStatus(this.status, this.search, this.view, this.currentPage).then((results) => {
                    this.handleCampaignResponse(results);
                });
            } else {
                this.campaignRepo.findAllByStatus(this.status, this.currentPage, this.view).then((results) => {
                    this.handleCampaignResponse(results);
                });
            }
        }
    };

    searchByStatus() {
        if (this.searchTimeout) {
            this._timeout.cancel(this.searchTimeout);
        }

        this.searchTimeout = this._timeout(() => {
            this.setPage();
        }, 500);
    };

    clearSearch() {
        this.search = "";
        this.campaigns = [];
        this.transactions = [];
        this.currentPage = 1;
    };

    handleCampaignResponse(results) {
        this.fetchingCampaigns = false;

        this.meta = results.meta;
        this.meta.pageTotal = (this.meta['matchingCount'] != null) ? this.meta['matchingCount'] : results.meta.total[this.status];

        angular.forEach(results.campaigns, (campaign) => {
            var isAbTest = this.isAbTest(campaign);

            if (isAbTest) {
                switch (this.status) {
                    case 'sent':
                        campaign.enabledButtons = { statistics: true, remove: true };
                        break;
                    case 'sending':
                        campaign.enabledButtons = { pauseAbTest: true };
                        break;
                    case 'paused':
                        campaign.enabledButtons = { restartAbTest: true };
                        break;
                }
            }

            var statusName = isAbTest ? this.abTestStatusMap[campaign.ab_test_status_id] : campaign.status.name;
            campaign.utm_info = isAbTest ? this.buildUtmInfoForABTest(campaign) : this.buildUtmInfoForCampaign(campaign);
            campaign.statistics = false;
            campaign.date = this._filter('toDate')(campaign.updated_at, 'yyyy-MM-dd');

            if (! campaign.enabledButtons) {
                campaign.enabledButtons = this.optionsByStatus[statusName];
            }

            if (statusName == 'scheduled') {
                var repository = isAbTest ? this.abTestRepository : this.campaignRepo;
                repository.getSchedule(campaign.id).then((schedule) => {
                    campaign.scheduledFor = [];
                    if (schedule) {
                        campaign.scheduledFor['date'] = this._filter('toDate')(schedule.date, 'spoken');
                        campaign.scheduledFor['time'] = schedule.time.hour + ':' + schedule.time.minutes;
                    } else {
                        campaign.scheduledFor['date'] = this._filter('translate')('CAMPAIGN:INDEX:NO_SCHEDULE');
                        campaign.scheduledFor['time'] = '';
                    }
                });
            }
            this.campaigns.push(campaign);
        });

        if (this.status !== 'draft' && this.status !== 'scheduled') {
            angular.forEach(this.campaigns, (campaign) => {
                if (! this.isAbTest(campaign)) {
                    this.statisticRepo.widgetStatistics(campaign.id, 'campaign').then((statistics) => {
                        campaign.statistics = statistics;
                    });
                } else if (this.isAbTest(campaign)) {
                    this.statisticRepo.widgetStatistics(campaign.id, 'abTest').then((statistics) => {
                        campaign.statistics = statistics;
                    });
                }
            });
        }
    };

    buildUtmInfoForABTest(abTest) {
        var utm_info = '';

        abTest.campaigns.forEach((campaign) => {
            if (campaign.emails[0] && campaign.emails[0].ga_utm_campaign != '') {
                var prefix = utm_info == '' ? 'Utms: ' : ', ';
                utm_info += prefix + campaign.emails[0].ga_utm_campaign;
            }
        });

        return utm_info;
    };

    buildUtmInfoForCampaign(campaign) {
        return campaign.emails[0] ? campaign.emails[0].ga_utm_campaign : null;
    };

    handleTransactionalResponse(results) {
        this.meta = results.meta.pagination;
        this.transactionCount = this.meta.pageTotal = this.meta.total;
        this.transactions = results.data;

        angular.forEach(this.transactions, (transaction) => {
            this.statisticRepo.widgetStatistics(transaction.id, 'transactional').then((statistics) => {
                transaction.statistics = statistics;
            });
        });
    };

    setStatus(status) {
        this._state.go('campaign.folder', { folder: status, view: this.view, page: 1 });
    };

    exportCampaigns() {
        this.exportRunning = true;
        this.campaignRepo.export(this.currentPage, this.search, this.view).then(() => {
            this._rootScope.$emit('progress:start', 'campaign-export');
        });
    };

    downloadExport() {
        this._window.open(this.exportFileUrl);
    };

    showNoCampaigns() {
        return this.status == 'sent' && ! this.fetchingCampaigns && (! this.search || ! this.search.length) && ! this.campaigns.length;
    };

    removeExport(event) {
        event.stopPropagation();

        this.campaignRepo.removeExport().then(() => {
            this.exportFileUrl = null;
            this.eventHandler.flashEvent('notification', this._filter('translate')('CAMPAIGN:INDEX:EXPORT_DELETED'));
        });
    };
};
